<template lang="html">
  <div v-bind:class="{ 'no-results': products && !products.length }">
    <!-- Loaders -->
    <div v-if="loading" class="loader loader--bar">
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <span class="loader__text">{{
        dict["indlæser produkter"] || "Indlæser produkter..."
      }}</span>
    </div>
    <div
      v-if="refreshing"
      class="loader--indeterminate"
      aria-hidden="true"
    ></div>
    <!-- Sticky facets -->
    <facets-head
      v-else-if="showFacets"
      :open="open"
      @toggle="toggle"
    ></facets-head>

    <!-- Product tiles -->
    <div class="d-flex">
      <transition :name="transitionName">
        <Facets
          @toggle="toggle"
          :open="open"
          v-if="open && facets.length > 0"
        ></Facets>
      </transition>
      <div class="row products products--app" v-if="products && products.length > 0">
        <template v-for="product in products">
          <div :class="productColumnClass" v-if="!product.isTeaser">
            <product-tile :product="product"></product-tile>
          </div>
          <div :class="productColumnClass" v-else>
            <teaser-tile :teaser="product"></teaser-tile>
          </div>
        </template>
      </div>
      <div class="row mt-4 products" v-else-if="!refreshing">
        <div class="col-12 text-center">
          <div class="p-4 bg-light p-4 text-center lead">
            {{ dict["ingen produkter"] }}
          </div>
          <a href="/" class="btn btn-cta my-5">{{
            dict["tilbage til forsiden"] || "Tilbage til forsiden"
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import FacetsHead from "./components/FacetsHead";
import ProductTile from "./components/ProductTile";
import TeaserTile from "./components/TeaserTile";
import Facets from "./components/Facets";

export default Vue.extend({
  name: "Products",
  components: {
    FacetsHead,
    ProductTile,
    TeaserTile,
    Facets
  },
  props: [],
  data() {
    return {
      open: false,
      loading: true,
      hasParams: false,
      transitionName: "",
      mqIsDesktop: window.matchMedia("(min-width: 992px)")
    };
  },
  created() {
    // Get stored scrollstate
    let _y = window.history.state?.scrollY;

    // Get dictionaries
    this.$store.dispatch("dictionary");

    // Get facets and seachquery from URL
    let params = getSelectedFacetsFromURL();

    if (params.collectionMode) {
      this.$store.commit("COLLECTIONMODE", params.collectionMode);
    }

    if (params.query) {
      this.$store.commit("QUERY", params.query);
      this.hasParams = true;
    }

    this.$store
      .dispatch("search", {
        selectedFacets: params.facets,
        query: params.query
      })
      .then((response) => {
        this.loading = false;
        if (_y !== undefined) {
          Vue.nextTick().then(() => window.scrollTo({ top: _y }));
        }

        // Avoid initial animation
        setTimeout(() => {
          this.transitionName = "reveal";
        }, 500);
      });

      this.mqIsDesktop.onchange = (e) => this.toggle(false);
  },
  methods: {
    toggle(toggleTo) {
      this.open = toggleTo;
      if(this.open && window.matchMedia("(max-width: 767px)").matches){
        document.body.classList.add("scroll--disabled");
      } else {
        document.body.classList.remove("scroll--disabled");
      }
    }
  },
  computed: {
    ...mapState([
      "products",
      "settings",
      "dict",
      "refreshing",
      "collectionMode",
      "facets"
    ]),
    showFacets() {
      let show = true;
      if (this.products && this.products.length) {
        const giftcardVar = this.products[0].name.split(" ");
        show = giftcardVar[0] !== "Gavekort";
      }
      return show ? !this.collectionMode : false;
    },
    productColumnClass() {
      return this.open
        ? "col-6 col-md-6 col-xl-4 px-0"
        : "col-6 col-sm-4 col-lg-3 px-0";
    }
  }
});

function getSelectedFacetsFromURL() {
  var searchParams = new URLSearchParams(window.location.search);
  if (document.getElementById("landingPageQuery"))
    searchParams = new URLSearchParams(
      document.getElementById("landingPageQuery").value
    );

  let params = {
    facets: [],
    query: "",
    collectionMode: searchParams.get("mode") === "showSerie"
  };

  searchParams.forEach((value, key) => {
    let _key = decodeURI(key);
    let isFacetParam = _key.indexOf("FACET_") === 0;
    if (isFacetParam) {
      params.facets.push({ [_key]: decodeURI(value) });
    } else if (_key === "query") {
      params.query = decodeURI(value);
    }
  });

  return params;
}
</script>
